/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
/* eslint-disable func-names */
import Phaser from 'phaser';
import EDC from './globals';
import MenuButton from './menu-button';
import store from '@/store/index';

EDC.Preloaders.Menu = function (scene) {
  const activeAccount = store.getters['children/activeChildProfile'];

  scene.load.setPath('../phaser-assets/images/menu/');
  scene.load.setPrefix('menu-');

  scene.load.image('bg', 'background.png');
  scene.load.image('btn-new-game-normal', 'btn-new-game-normal.png');
  scene.load.image('btn-new-game-hover', 'btn-new-game-hover.png');
  scene.load.image('btn-play-normal', 'btn-play-normal.png');
  scene.load.image('btn-play-hover', 'btn-play-hover.png');
  scene.load.image('btn-switch-normal', 'btn-switch-normal.png');
  scene.load.image('btn-switch-hover', 'btn-switch-hover.png');
  scene.load.image('btn-sign-in-normal', 'btn-signin-normal.png');
  scene.load.image('btn-sign-in-hover', 'btn-signin-hover.png');
  scene.load.image('btn-parent-site-normal', 'btn-parent-site-normal.png');
  scene.load.image('btn-parent-site-hover', 'btn-parent-site-hover.png');
  scene.load.image('btn-exit-normal', 'btn-exit-normal.png');
  scene.load.image('btn-exit-hover', 'btn-exit-hover.png');
  scene.load.image('btn-new-normal', 'btn-new-normal.png');
  scene.load.image('btn-new-hover', 'btn-new-hover.png');
  scene.load.image('btn-link-normal', 'btn-link-normal.png');
  scene.load.image('btn-link-hover', 'btn-link-hover.png');
  scene.load.image('light', 'light.png');

  if (activeAccount && activeAccount.avatar) {
    scene.load.setPath('https://images.growmindgrow.com/avatars/');
    scene.load.image('account-image', activeAccount.avatar);
    // scene.load.setCORS('anonymous');
  }

  scene.load.setPath();
  scene.load.setPrefix();
};
/**
 * Menu scene
 */
EDC.UI.Menu = function () {
  this.bg = null;
  this.isShowed = false;
  this.noKeyboard = false;
  this.buttonsContainer = null;
  this.buttonsStartY = 0;
  this.stepBetweenButtons = 95;
  this.menuEvents = new Phaser.Events.EventEmitter();
  this.controlScenes = [];
  this.buttons = {};
  this.sprites = {
    'new-game': {
      normal: 'menu-btn-new-game-normal',
      hover: 'menu-btn-new-game-hover',
    },
    play: {
      normal: 'menu-btn-play-normal',
      hover: 'menu-btn-play-hover',
    },
    'new-player': {
      normal: 'menu-btn-new-normal',
      hover: 'menu-btn-new-hover',
    },
    'link-player': {
      normal: 'menu-btn-link-normal',
      hover: 'menu-btn-link-hover',
    },
    switch: {
      normal: 'menu-btn-switch-normal',
      hover: 'menu-btn-switch-hover',
    },
    'sign-in': {
      normal: 'menu-btn-sign-in-normal',
      hover: 'menu-btn-sign-in-hover',
    },
    parent: {
      normal: 'menu-btn-parent-site-normal',
      hover: 'menu-btn-parent-site-hover',
    },
    exit: {
      normal: 'menu-btn-exit-normal',
      hover: 'menu-btn-exit-hover',
    },
  };
};
/**
 *
 */
EDC.UI.Menu.prototype.addControlScene = function (scene) {
  this.controlScenes.push(scene);
};
/**
 *
 */
EDC.UI.Menu.prototype.create = function () {
  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'menu-bg');
  this.bg.setScale(0.9);
  this.bindKey();

  this.buttonsContainer = this.add.container(this.bg.x, this.bg.y - 10);
  // this.buttonsContainer.setVisible(false);

  this.bg.y -= this.bg.height;
  this.menuEvents.emit('EVT_MENU_CREATED');
};
/**
 *
 */
EDC.UI.Menu.prototype.getMenuBg = function () {
  return this.bg;
};

// eslint-disable-next-line max-len
EDC.UI.Menu.prototype.addButton = function (id, onClick, onOver = null, onOut = null, additionalStep = 0) {
  if (!this.sprites.hasOwnProperty(id)) {
    console.error('No sprites for button with ID: ', id);
    return;
  }

  const imgs = this.sprites[id];
  const btnY = this.buttonsContainer.getAll().length * this.stepBetweenButtons + additionalStep;
  const btn = new MenuButton(this, 0, btnY).create(imgs.normal, imgs.hover, null, imgs.disabled);
  const btnContainer = btn.getContainer();
  btn.setClickCallback(onClick);
  btn.setOverCallback(onOver);
  btn.setOutCallback(onOut);
  btn.setScale(0.9);

  this.buttonsContainer.add(btnContainer);
  this.buttons[id] = btn;

  return btnContainer;
};
/**
 *
 */
EDC.UI.Menu.prototype.getButtonById = function (id) {
  if (this.buttons.hasOwnProperty(id)) {
    return this.buttons[id];
  }
  console.error('Menu button with ID ', id, ' not exists');
};
/**
 *
 */
EDC.UI.Menu.prototype.bindKey = function () {
  this.input.keyboard.on('keyup-ESC', () => {
    this.onEscPress();
  });
};
/**
 *
 */
EDC.UI.Menu.prototype.onEscPress = function () {
  if (this.noKeyboard) return;
  if (!this.isShowed && document.referrer.indexOf(process.env.VUE_APP_PARENT_GAME_LIST) === -1) {
    this.show();
  } else {
    this.hide();
  }
};
/**
 *
 */
EDC.UI.Menu.prototype.pauseControlScenes = function () {
  for (let i = 0; i < this.controlScenes.length; i++) {
    this.controlScenes[i].scene.pause();
  }
};
/**
 *
 */
EDC.UI.Menu.prototype.resumeControlScenes = function () {
  for (let i = 0; i < this.controlScenes.length; i++) {
    this.controlScenes[i].scene.resume();
  }
};
/**
 *
 */
EDC.UI.Menu.prototype.show = function (noAnimation) {
  this.pauseControlScenes();
  this.isShowed = true;

  if (noAnimation) {
    this.bg.y += this.bg.height;
    this.buttonsContainer.setVisible(true);
  } else {
    this.tweens.add({
      targets: this.bg,
      y: this.bg.y + this.bg.height,
      duration: 400,
      ease: 'Back.easeOut',
      onComplete: function () {
        this.buttonsContainer.setVisible(true);
      }.bind(this),
    });
  }
};
/**
 *
 */
EDC.UI.Menu.prototype.hide = function (callback) {
  this.buttonsContainer.setVisible(false);

  this.tweens.add({
    targets: this.bg,
    y: this.bg.y - this.bg.height,
    duration: 400,
    ease: 'Back.easeIn',
    onComplete: function (callback) {
      if (callback) callback();
      this.isShowed = false;
      this.resumeControlScenes();
    }.bind(this, callback),
  });
};

const exportMenu = EDC.UI.Menu;
const exportPreloader = EDC.Preloaders.Menu;

export { exportMenu as Menu, exportPreloader as MenuPreloader };
